import React from "react";
import { Modal, StyleSheet, Text, View } from "react-native";

import PrimaryButton from "../../../../../../common/native/PrimaryButton";
import SecondaryButton from "../../../../../../common/native/SecondaryButton";
import { APP_TOKENS as tokens } from "../../../../../../../styles/tokens";
import {
  INCOMPLETE_CHUNK_RECOVERY_MESSAGE,
  INCOMPLETE_CHUNK_RECOVERY_TITLE,
} from "../../chunkedAudioRecovery";

type IncompleteChunkRecoveryModalProps = {
  visible: boolean;
  onCancel: () => void;
  onRecover: () => void;
};

const IncompleteChunkRecoveryModal: React.FC<
  IncompleteChunkRecoveryModalProps
> = ({ visible, onCancel, onRecover }) => (
  <Modal
    visible={visible}
    transparent
    animationType="none"
    onRequestClose={onCancel}
  >
    <View style={styles.overlay} accessibilityViewIsModal>
      <View style={styles.content}>
        <Text accessibilityRole="header" style={styles.title}>
          {INCOMPLETE_CHUNK_RECOVERY_TITLE}
        </Text>
        <Text style={styles.message}>{INCOMPLETE_CHUNK_RECOVERY_MESSAGE}</Text>
        <Text style={styles.detail}>
          Only the continuous saved portion will be processed. The original
          chunks will remain available.
        </Text>
        <View style={styles.actions}>
          <SecondaryButton
            text="Cancel"
            onPress={onCancel}
            accessibilityLabel="Cancel audio recovery"
          />
          <PrimaryButton
            text="Recover Audio"
            onPress={onRecover}
            accessibilityLabel="Recover saved audio chunks"
          />
        </View>
      </View>
    </View>
  </Modal>
);

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: tokens.color.overlay,
    padding: tokens.spacing.lg,
  },
  content: {
    width: "100%",
    maxWidth: tokens.spacing.giant * 7,
    gap: tokens.spacing.md,
    padding: tokens.spacing.xxl,
    borderRadius: tokens.radius.lg,
    backgroundColor: tokens.color.surface,
    ...tokens.shadow.card,
  },
  title: {
    color: tokens.color.textPrimary,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.xl,
    lineHeight: tokens.lineHeight.xl,
  },
  message: {
    color: tokens.color.textSecondary,
    fontFamily: tokens.font.regular,
    fontSize: tokens.fontSize.md,
    lineHeight: tokens.lineHeight.md,
  },
  detail: {
    color: tokens.color.textMuted,
    fontFamily: tokens.font.regular,
    fontSize: tokens.fontSize.sm,
    lineHeight: tokens.lineHeight.sm,
  },
  actions: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    gap: tokens.spacing.md,
    marginTop: tokens.spacing.sm,
  },
});

export default IncompleteChunkRecoveryModal;
